import React from "react";
import '../Common.scss';
import './Elevation2.scss';
import defaultImage from '../../../assets/default.png';
export default class ElevationMaterial extends React.Component<any, any>{
    render() {
        const { pageDetails } = this.props;
        const { shutterDetails,sectionDetails ,elevationImage} = pageDetails || {};
        return (
            <React.Fragment>
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}?ver=${new Date().getTime()}`: defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className="details-tables">
                    <div className="table-header">
                        <div className="details-heading-wrapper details-heading">
                            SHUTTER SPECIFICATIONS
                            {/* <div className="details-heading-subtext">(*Current data is set as per global material settings)</div> */}
                        </div>
                        <div className="details">
                            {
                                shutterDetails && Object.keys(shutterDetails).map((key, index) => {
                                    const details = shutterDetails[key];
                                    if(details){
                                        let heading = details['heading'];;
                                        if (key === "laminateDetails")
                                            heading = "LAMINATE DETAILS";
                                        return (<React.Fragment>
                                            <div className="details-table">
                                                <React.Fragment>
                                                {
                                                    (key.includes('colorSpecificationList') && details.length) ? 
                                                        <React.Fragment>
                                                            <div className="table-row">
                                                                <div className="table-cell color-heading">
                                                                    {"NAME"}
                                                                </div>
                                                                <div className="table-cell color-heading">
                                                                    {"LAMINATE COLOR"}
                                                                </div>
                                                                <div className="table-cell color-heading">
                                                                    {"CODE"}
                                                                </div>
                                                            </div>
                                                        </React.Fragment> 
                                                    : heading ? <React.Fragment>
                                                             <div className="table-heading"> {heading} </div>
                                                             <div className="table-row">
                                                                <div className="table-cell color-heading">{pageDetails.name.includes('shutter_material')?'FRAME NAME':'SHUTTER MATERIAL'}</div>
                                                                <div className="table-cell color-heading">{pageDetails.name.includes('shutter_material')?'FRAME COLOR':'SHUTTER FINISH'}</div>
                                                            </div>
                                                        </React.Fragment>: key === "handleData" ? <><div className="table-heading"> Handle Details </div></> : ""   
                                                }
                                                </React.Fragment>
                                                {
                                                    Array.isArray(details) ?
                                                        details.map((arrObj, index) => {
                                                            return (
                                                                <React.Fragment key={index}>
                                                                    {
                                                                        key.includes('colorSpecificationList') ? 
                                                                            <div className="table-row">
                                                                                <div className="table-cell">
                                                                                    {arrObj?.annotationName}
                                                                                </div>
                                                                                <div className="table-cell">
                                                                                    {arrObj?.laminateColorName}
                                                                                </div>
                                                                                <div className="table-cell">
                                                                                    {arrObj?.laminateColorCode}
                                                                                </div>
                                                                            </div>
                                                                            : key.includes('handleData') ?
                                                                                <div className="table-row">
                                                                                    <div className="table-cell">
                                                                                        Handle
                                                                                    </div>
                                                                                    <div className="table-cell">
                                                                                        {arrObj?.hasHandle ? 'Yes' : "No"}
                                                                                    </div>
                                                                                </div>
                                                                        :  <div className="table-row">
                                                                                <div className="table-cell">{arrObj}</div>
                                                                                <div className="table-cell">{arrObj}</div>
                                                                            </div> 
                                                                    }
                                                                </React.Fragment>
                                                            );
                                                        })
                                                    : Object.keys(details).map((key, index) => {
                                                        if (key !== "heading" && details[key]) {
                                                              return  Array.isArray(details[key])?
                                                                details[key].map((obj,index)=> {
                                                                    return obj && <React.Fragment>
                                                                    <div className="table-row">
                                                                        <div className="table-cell">
                                                                            {obj.shutterMaterial?obj.shutterMaterial:obj.frameName}
                                                                        </div>
                                                                        <div className="table-cell">
                                                                            {obj.shutterFinish?obj.shutterFinish:obj.frameColor}
                                                                        </div>
                                                                        
                                                                    </div>
                                                                </React.Fragment>
                                                                })
                                                                : <React.Fragment>
                                                                    <div className="table-row">
                                                                        <div className="table-cell">
                                                                            {details[key]['name'] ? details[key]['name'].toString().toUpperCase() : key.toString().toUpperCase()}
                                                                        </div>
                                                                    </div>
                                                                </React.Fragment>
                                                        }
                                                        return null;
                                                    })
                                                }
                                            </div>
                                        </React.Fragment>)
                                        
                                    }
                                   return null;
                                })
                            }
                            {
                                sectionDetails && Object.keys(sectionDetails).map((key,index) =>{
                                    const details = sectionDetails[key];
                                    if(details){
                                        return (
                                            <React.Fragment>
                                                <div className="details-table-shutter">
                                                <React.Fragment>
                                                   {
                                                    (key.includes('sectionDataList') && details.length) ? 
                                                        <React.Fragment>
                                                            <div className="table-row">
                                                                <div className="table-cell color-heading">
                                                                    {"ORIENTATION"}
                                                                </div>
                                                                <div className="table-cell color-heading">
                                                                    {"WIDTH(MM)"}
                                                                </div>
                                                                <div className="table-cell color-heading">
                                                                    {"HEIGHT(MM)"}
                                                                </div>
                                                                <div className="table-cell color-heading">
                                                                    {"DESIGN"}
                                                                </div>
                                                            </div>
                                                        </React.Fragment> :""
                                                    }
                                                    {
                                                            details?.map((arrObj, index) => {
                                                                return (
                                                                    <React.Fragment key={index}>
                                                                        {
                                                                            key.includes('sectionDataList') ? 
                                                                                <div className="table-row">
                                                                                    <div className="table-cell">
                                                                                        {arrObj.orientation}
                                                                                    </div>
                                                                                    <div className="table-cell">
                                                                                        {arrObj.width}
                                                                                    </div>
                                                                                    <div className="table-cell">
                                                                                        {arrObj.height}
                                                                                    </div>
                                                                                    <div className="table-cell">
                                                                                        {arrObj.designSection}
                                                                                    </div>
                                                                                </div>
                                                                            :  <div className="table-row">
                                                                                    <div className="table-cell">{arrObj}</div>
                                                                                    <div className="table-cell">{arrObj}</div>
                                                                                </div> 
                                                                        }
                                                                    </React.Fragment>
                                                                );
                                                            })
                                                    
                                                }
                                                </React.Fragment>
                                                </div>

                                            </React.Fragment>
                                        )
                                    }
                                    return null;
                                })
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>

        )
    }
}